import React from 'react';

const Azure = () => {
    return (
        <>
            <div className="breadcrumb-area">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="breadcrumb_box text-center">
                                <h2 className="breadcrumb-title">Microsoft Azure</h2>
                                <ul className="breadcrumb-list">
                                    <li className="breadcrumb-item"><a href="/">Home</a></li>
                                    <li className="breadcrumb-item"><a href="/technologies">Technologies</a></li>
                                    <li className="breadcrumb-item active">Azure</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="service-details-wrapper section-space--ptb_100">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8">
                            <div className="content-area">
                                <div className="service-details-content">
                                    <h1>Microsoft Azure: Comprehensive Cloud Platform</h1>
                                    
                                    <p className="lead">Microsoft Azure is a cloud computing service that offers a vast array of services including computing, analytics, storage, and networking. It's ideal for enterprises with existing Microsoft infrastructure and complex compliance requirements.</p>

                                    <h3 className="mt-50">Enterprise-Grade Cloud Excellence</h3>
                                    <p>Azure delivers world-class cloud services with deep Microsoft ecosystem integration. It's the preferred choice for enterprises requiring hybrid cloud, advanced security, and regulatory compliance.</p>

                                    <h3 className="mt-40">Azure Service Portfolio</h3>
                                    <ul>
                                        <li><strong>Azure App Service:</strong> Host web apps, APIs, and mobile backends</li>
                                        <li><strong>Azure SQL Database:</strong> Managed relational database with auto-scaling</li>
                                        <li><strong>Azure Cosmos DB:</strong> Globally distributed NoSQL database</li>
                                        <li><strong>Azure Kubernetes Service:</strong> Managed Kubernetes for containerized apps</li>
                                        <li><strong>Azure Functions:</strong> Serverless computing with event-driven architecture</li>
                                        <li><strong>Azure DevOps:</strong> Complete CI/CD and project management</li>
                                        <li><strong>Azure Machine Learning:</strong> Enterprise-grade ML platform</li>
                                        <li><strong>Azure Security & Compliance:</strong> Bank-level security and certifications</li>
                                    </ul>

                                    <h3 className="mt-40">Real-World Azure Deployments</h3>
                                    <p><strong>Enterprise Digital Transformation:</strong> Organizations migrating from on-premises to cloud using Azure's hybrid capabilities.</p>
                                    <p><strong>Global SaaS Platforms:</strong> Multi-region deployments with Cosmos DB and Azure CDN.</p>
                                    <p><strong>Industry-Specific Solutions:</strong> Healthcare, finance, and government compliance requirements.</p>

                                    <h3 className="mt-40">AppCore's Azure Expertise</h3>
                                    <div className="case-study-box mt-30">
                                        <h5>Success: Enterprise Cloud Migration</h5>
                                        <p>We migrated a large enterprise to Azure:</p>
                                        <ul>
                                            <li>☁️ Hybrid cloud setup with on-premises integration</li>
                                            <li>💰 40% cost savings vs on-premises</li>
                                            <li>🔒 Maintained SOC2 and HIPAA compliance</li>
                                            <li>🚀 99.95% uptime SLA</li>
                                        </ul>
                                    </div>

                                    <h3 className="mt-40">Advanced Azure Patterns</h3>
                                    <ul>
                                        <li>Hybrid cloud architecture with Azure Stack</li>
                                        <li>Multi-region disaster recovery</li>
                                        <li>Azure Service Bus for messaging</li>
                                        <li>Event Grid for event-driven architecture</li>
                                        <li>Azure Pipelines for CI/CD automation</li>
                                        <li>Azure Monitor for comprehensive logging</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <div className="sidebar-area">
                                <div className="sidebar-widget mb-50">
                                    <h5 className="widget-title mb-30">Azure Strengths</h5>
                                    <ul className="sidebar-list">
                                        <li>🔗 Microsoft Integration</li>
                                        <li>🏢 Enterprise Ready</li>
                                        <li>☁️ Hybrid Cloud</li>
                                        <li>🔒 Compliance Leader</li>
                                        <li>🌍 Global Infrastructure</li>
                                        <li>💼 Enterprise Support</li>
                                    </ul>
                                </div>

                                <div className="sidebar-widget">
                                    <h5 className="widget-title mb-30">Deployment Statistics</h5>
                                    <div className="metric-item mb-20">
                                        <p className="metric-label">Azure Projects</p>
                                        <p className="metric-value" style={{color: '#64b1a6', fontSize: '24px', fontWeight: 'bold'}}>20+</p>
                                    </div>
                                    <div className="metric-item mb-20">
                                        <p className="metric-label">Avg Uptime</p>
                                        <p className="metric-value" style={{color: '#64b1a6', fontSize: '24px', fontWeight: 'bold'}}>99.95%</p>
                                    </div>
                                    <div className="metric-item">
                                        <p className="metric-label">Enterprise Clients</p>
                                        <p className="metric-value" style={{color: '#64b1a6', fontSize: '24px', fontWeight: 'bold'}}>15+</p>
                                    </div>
                                </div>

                                <div className="sidebar-widget mt-50">
                                    <h5 className="widget-title mb-30">Enterprise Trust</h5>
                                    <p className="small">Global enterprises choose Azure for hybrid cloud, Microsoft ecosystem integration, and unmatched compliance certifications.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Azure;
